import checked from './checked';
import unchecked from './unchecked';

export default {
	checked,
	unchecked
}
